import { c as _c } from "react/compiler-runtime";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@repo/design-system/components/ui/breadcrumb";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import { useLanguage } from "~/translations/loader/use-language";
import type { JobadComponentProps } from "~/types/job";
export default function BreadcrumbEon(t0) {
  const $ = _c(14);
  const {
    job
  } = t0;
  const t = useLanguage();
  const locale = useLocale();
  let t1;
  if ($[0] !== t.breadcrumb_home) {
    t1 = <BreadcrumbItem><BreadcrumbLink asChild={true} className="text-black"><CustomLink href="/">{t.breadcrumb_home}</CustomLink></BreadcrumbLink></BreadcrumbItem>;
    $[0] = t.breadcrumb_home;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== job.data.locations[0] || $[3] !== job.data.locations.length || $[4] !== locale || $[5] !== t.breadcrumb_jobsIn) {
    t2 = job.data.locations.length <= 1 && <><BreadcrumbSeparator /><BreadcrumbItem><BreadcrumbLink asChild={true} className="text-black"><CustomLink blank={true} className="hover:underline" href={`/?locations.cityState=${job.data.locations[0].cityState.replace(/,/g, "_IN_")}`} locale={locale}><span data-source="lc">{t.breadcrumb_jobsIn} </span><span data-source="job">{job.data.locations[0].city}</span></CustomLink></BreadcrumbLink></BreadcrumbItem></>;
    $[2] = job.data.locations[0];
    $[3] = job.data.locations.length;
    $[4] = locale;
    $[5] = t.breadcrumb_jobsIn;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <BreadcrumbSeparator />;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== job.data.title) {
    t4 = <BreadcrumbItem><BreadcrumbPage className="font-bold">{job.data.title}</BreadcrumbPage></BreadcrumbItem>;
    $[8] = job.data.title;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <section className="outer-container py-6"><div className="inner-container"><Breadcrumb><BreadcrumbList className="text-lg">{t1}{t2}{t3}{t4}</BreadcrumbList></Breadcrumb></div></section>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}